import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    standalone: true,
    selector: 'app-multi-select-clear',
    imports: [TranslateModule],
    host: {
        class: 'mat-select-search-custom-header-content multi-clear-btn',
        type: 'button',
        '(click)': 'onClear($event)',
    },
    templateUrl: './multi-select-clear.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./multi-select-clear.component.scss']
})
export class MultiSelectClearComponent {
    @Output() cleared = new EventEmitter<void>();

    onClear(event: Event): void {
        event.stopPropagation();
        this.cleared.emit();
    }
}
